import IQuoteRecordAttributesBase from '../types/quoteRecordAttributesBase';

export const getAddressAttrsAEnd = (attributes: IQuoteRecordAttributesBase): any => {
  if (
    (attributes.a_end_data_centre_id && attributes.a_end_data_centre_id !== '-1') ||
    attributes.a_end_colt_building_id
  ) {
    return {
      colt_building_id: attributes.a_end_colt_building_id || '',
      pop_id: attributes.a_end_data_centre_id || '',
      reference: attributes.meta!.a_end_on_net_reference || attributes.a_end_data_centre_reference || '',
      location: attributes.meta!.a_end_on_net_location || attributes.a_end_data_centre_address || '',
      name: attributes.meta!.a_end_on_net_name || attributes.a_end_data_centre_name || '',
      address_1: attributes.a_end_building_name || '',
      address_2: attributes.a_end_full_site_thoroughfare || '',
      town: attributes.a_end_full_site_town || '',
      county: attributes.a_end_full_site_county || '',
    };
  } else {
    return {
      uprn: attributes.a_end_uprn || '',
      udprn: attributes.a_end_udprn || '',
      organisation_name: attributes.a_end_paf_organisation_name || '',
      building_name: attributes.a_end_building_name || '',
      building_number: attributes.a_end_building_number || '',
      county: attributes.a_end_full_site_county || '',
      postcode: attributes.a_end_postcode?.toUpperCase() || '',
      thoroughfare: attributes.a_end_full_site_thoroughfare || '',
      post_town: attributes.a_end_full_site_town || '',
      sub_building: attributes.a_end_sub_building || '',
    };
  }
};
